import type { CuratedDealBuyerDiscountSeatOption } from '../../../../types/curatedDealBuyerDiscount.ts';
import type { CuratedDealBuyerDiscountSeat } from '../types.ts';

export const seatOptionsToCuratedDealBuyerDiscountSeats = <T extends CuratedDealBuyerDiscountSeatOption | null>(
  options: T[] | undefined
) => {
  if (!options) {
    return [];
  }

  return options.reduce<CuratedDealBuyerDiscountSeat[]>((acc, option) => {
    if (option) {
      acc.push({
        buyer_path: option.extra.buyer_path,
        demand_partner_id: option.extra.demand_partner_id,
        id: option.id,
        name: option.name,
        seat_id: option.extra.seat_id,
        used_by_curateddealbuyerdiscount: option.extra.used_by_curateddealbuyerdiscount,
      });
    }

    return acc;
  }, []);
};
